






























import { Component, Prop, Vue } from "vue-property-decorator";
import ComplianceHeader from "../components/ComplianceHeader.vue";
import Burger from "@/components/Burger.vue";

@Component({
  components: { Burger, ComplianceHeader }
})
export default class PageHeader extends Vue {
  @Prop({ default: true }) private showCompliance!: boolean;

  getLinks() {
    return [
      { title: "Home", route: "/", isSelected: this.$route.path === "/" },
      {
        title: "Research Areas",
        route: "/categories",
        isSelected:
          this.$route.path.indexOf("/categor") === 0 ||
          this.$route.path.indexOf("/comparison") === 0
      },
      {
        title: "Article Keywords",
        route: "/keywords",
        isSelected: this.$route.path.indexOf("/keyword") === 0
      }
    ];
  }

  handleUserAcceptance(userAccepted: boolean) {
    this.$emit("user-acceptance", userAccepted);
  }
}
